import Cookies from 'js-cookie';
import { create } from 'zustand';

export type UserRole = 'admin' | 'management' | 'preparing' | 'packaging' | 'pieces_auditor';

export interface AuthState {
    user: { name: string; phone: string } | null;
    sessionId: string | null;
    licenceId: string | null;
    userRole: UserRole | null;
    setLicenceId: (id: string) => void;
    setUserRole: (role: UserRole) => void;
    setUser: (user: { name: string; phone: string } | null) => void;
    syncAuth: () => void;
}

const getInitialUser = () => {
    try {
        const userCookie = Cookies.get('user');
        if (!userCookie) return null;
        const parsed = JSON.parse(userCookie);
        return Array.isArray(parsed) ? parsed[0] : parsed;
    } catch {
        return null;
    }
};

export const getRoleFromOptions = (options: any[]): UserRole | null => {
    const match = options.find((opt) => opt.option_name === 'orders_role');
    const role = match?.option_value as UserRole | undefined;
    const validRoles: UserRole[] = ['admin', 'management', 'preparing', 'packaging', 'pieces_auditor'];
    return role && validRoles.includes(role) ? role : null;
};

const getInitialRole = (): UserRole | null => {
    try {
        const storedOptions = localStorage.getItem('temp_options');
        const options = storedOptions ? JSON.parse(storedOptions) : [];
        return getRoleFromOptions(options);
    } catch {
        return null;
    }
};

export const useAuthStore = create<AuthState>((set) => ({
    user: getInitialUser(),
    sessionId: Cookies.get('sessionId') || null,
    licenceId: localStorage.getItem('licence_id') || null,
    userRole: getInitialRole(),

    setLicenceId: (id: string) => {
        if (!id) return;
        localStorage.setItem('licence_id', id);
        set({ licenceId: id });
    },

    setUserRole: (role: UserRole) => set({ userRole: role }),

    setUser: (user) => set({ user }),
    syncAuth: () => {
        set({
            user: getInitialUser(),
            sessionId: Cookies.get('sessionId') || null,
            licenceId: localStorage.getItem('licence_id') || null,
            userRole: getInitialRole(),
        })
    }
}));